import React from 'react';
import { Forbidden } from 'app/components';

export const ForbiddenView: React.FC = () => {
  return (
    <div style={{ width: '100vw', height: '100vh' }}>
      <Forbidden />
    </div>
  );
};

export default ForbiddenView;
